import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild, HostListener } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute} from '@angular/router';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { SwUpdate } from '@angular/service-worker';
import { MenuController, Platform, ToastController, PopoverController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Storage } from '@ionic/storage';
import { filter } from 'rxjs/operators';

import { MyService, PusherServiceProvider } from './providers/myService';

import { SearchbarService } from './pages/schedule/searchbar.service';
import { NotificationService } from './providers/notification.service';
import { NotificationsPopover } from './pages/notifications-popover/notifications-popover';

import { UserData } from './providers/user-data';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {

  @ViewChild('profileWrapper', { static: false }) profileWrapper!: ElementRef;
  Name = '';
  Email = '';
  Username = '';
  dataUser = [];
  sessionDetal: any = [];
  Img= '';
  showSearchbar = false;
  profileDropdownOpen = false;
  profileDropdownOpen2 = false;
  unreadCount = 0;
  unreadMessageCount = 0;



  apiUrl:any = 'https://app.walba.app/';
        Programid:any;
        PersonalTrainer:any;
        PersonalTraineravatar:any;
        Client:any;
        ProgramExercises:any;
        activeExerciseVideo:any;
        ExerciseNAme:any;
        momentTime:any = null;
        momentTimeDuration :any = null;
        CaloriaEjercite:any = null;
        showbar:any=true;
        showEjercicio:any=true;
        Idsession:any;



        // this will represent a new post by a user
        post: any = {};
        // this will represent your default pusher presence channel
        presence_channel: any;
        presence_channelE: any;
        presence_channelT: any;

        sanitizedURL: SafeResourceUrl;

        current_user;

        users_online = {
        };

         location = 'madison';
  conferenceDate = '2047-05-17';

  selectOptions = {
    header: 'Select a Location'
  };

  sendData:any;





              // list of default posts
      post_list = [
        {
          'username': 'og',
          'content': 'Making money was the plan oooo'
        },
        {
          'username': 'daddywon',
          'content': 'You can catch me on the express'
        }
      ];
        // this will represent the username of the current user


  loggedIn = false;
  dark = true;
  showMenu = true;
  showVideoCall = true;
   // <-- NEW flag to toggle layout

  constructor(
    private menu: MenuController,
    private platform: Platform,
    private router: Router,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private storage: Storage,
    private userData: UserData,
    private swUpdate: SwUpdate,
    private toastCtrl: ToastController,
    public myService: MyService,
    private activatedRoute: ActivatedRoute,
    private pusher: PusherServiceProvider,
    public domSanitizer: DomSanitizer,
    private searchbarService: SearchbarService,
    private eRef: ElementRef,
    private notifService: NotificationService,
    private popoverCtrl: PopoverController
  ) {


    this.initializeApp();

    // ⏬ Listen to route changes to hide menu on /videocall
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects.split('?')[0];

        this.showVideoCall = !url.includes('/videocall');
      });

      this.searchbarService.showSearchbar$.subscribe(value => {
      this.showSearchbar = value;
    });


  }

   async ngOnInit() {
    this.listenForLoginEvents();
    await this.userData.onReady();
    this.checkLoginStatus();
    this.loadUserData();

        await this.activatedRoute.queryParams.subscribe(async (params) => {

        console.log('Params: ' + params['Id'])
        this.Idsession = params['Id'];
        this.Programid = params['Program_Id'];
        this.PersonalTrainer = params['PersonalTrainer'];
        this.PersonalTraineravatar = params['Avatar'];
        this.Client = params['Client'];

        await this.myService.apiData('GET','/api/getScheduleProgramId/'+this.Idsession,null, null).subscribe(

      async (result) => {
        this.sessionDetal = result[0];
        console.log('SessionDetal: ' + this.sessionDetal)

      },
      //revisar esto
      (error) => {console.log(error);}

    );

    await this.myService.apiData('GET','/api/getProgramExercises/'+this.Programid,null, null).subscribe(

      (result) => {
        console.log(result);
        this.ProgramExercises = result;
      },
      //revisar esto
      (error) => {console.log(error);}

    );

     this.presence_channel = await this.pusher.init(this.Idsession);
    // update the list of users online
    await this.presence_channel.bind("App\\Events\\ExerciseVideo", async (data) => {

      console.log(data)

      this.activeExerciseVideo =  data.Exercise_Video;
      this.ExerciseNAme = data.Exercise_Name;

    })


     this.momentTime = await this.presence_channel.bind("App\\Events\\Timer", async (data) => {
      console.log(data);
      this.momentTime = data.Time.slice(0, -3);
      this.momentTimeDuration = data.Duration.slice(0, -3);
      this.showEjercicio = false;
      this.CaloriaEjercite = data.Calories_Lost;
    })

this.sanitizedURL = await this.domSanitizer.bypassSecurityTrustResourceUrl('https://videocall.walba.app/room/'+this.Idsession+'/'+this.Client);




    })






  /*  setInterval(() => {         //replaced function() by ()=>

    this.myService.apiData('GET','/api/getExerciseActive/'+this.Programid,null, null).subscribe(
      (result) => {
        if(result){
          console.log(result)
          if (result[0].Videos){
              this.activeExerciseVideo = result[0].Videos;
          }
        this.ExerciseNAme = result[0].Name
          console.log(result);
        }
      },
      //revisar esto
      (error) => {console.log(error);}

    );
    }, 10000);
*/



    /*this.myService.apiData('GET','/api/getScheduleProgramId/'+value.Id,null, null).subscribe(

      (result) => {
        this.sessionDetal = result[0];
        console.log('SessionDetal: ' + this.sessionDetal)

      },
      //revisar esto
      (error) => {console.log(error);}

    );*/



    this.swUpdate.available.subscribe(async () => {
      const toast = await this.toastCtrl.create({
        message: 'Update available!',
        position: 'bottom',
        buttons: [
          {
            role: 'cancel',
            text: 'Reload',
          },
        ],
      });

      await toast.present();

      toast
        .onDidDismiss()
        .then(() => this.swUpdate.activateUpdate())
        .then(() => window.location.reload());
    });


  }



  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  checkLoginStatus() {
    return this.userData.isLoggedIn().then((loggedIn) => {
      return this.updateLoggedInStatus(loggedIn);
    });
  }

   async openExerciseMenu() {
    await this.menu.open('rightMenu');
  }

  // Close the right menu
  async closeExerciseMenu() {
    await this.menu.close('rightMenu');
  }

  toggleProfileDropdown(event: Event) {
  event.stopPropagation(); // prevents closing immediately
  this.profileDropdownOpen = !this.profileDropdownOpen;
}

toggleProfileDropdown2(event: Event) {
  event.stopPropagation(); // prevents closing immediately
  this.profileDropdownOpen2 = !this.profileDropdownOpen2;
}

  async openNotifications(ev: any) {
    const popover = await this.popoverCtrl.create({
      component: NotificationsPopover,
      event: ev,
      translucent: true,
      cssClass: 'notifications-popover-class'
    });
    
    await popover.present();
    
    const { data } = await popover.onDidDismiss();
    if (data && data.url) {
       this.router.navigateByUrl(data.url);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    // If we don't have the reference yet, do nothing
    if (!this.profileWrapper) { return; }

    // normal contains check
    const clickedInside = this.profileWrapper.nativeElement.contains(event.target);

    // also check composedPath for webcomponents/shadow DOM (ionic web components)
    const path = (event as any).composedPath ? (event as any).composedPath() : [];
    const inComposedPath = path.indexOf(this.profileWrapper.nativeElement) > -1;

    if (!clickedInside && !inComposedPath) {
      this.profileDropdownOpen = false;
      this.profileDropdownOpen2 = false;
    }
  }



 closeDropdown(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.profileDropdownOpen = false;
    }
  }

  closeDropdown2(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.profileDropdownOpen2 = false;
    }
  }




  get_users_online() {
    return Object.keys(this.users_online).length - 1;
  }

  async isOnline(username: string) {
    if (username in this.users_online) {
      return 'online'
    } else {
      return 'offline'
    }
  }

  submitPost() {
    let self = this;
    // make a post request to the server
    let body = {
      'username': this.current_user,
      'content': this.post.content
    }
  }


  updateLoggedInStatus(loggedIn: boolean) {
    setTimeout(() => {
      this.loggedIn = loggedIn;
    }, 300);
  }

  listenForLoginEvents() {
    window.addEventListener('user:login', () => {
      this.updateLoggedInStatus(true);
      this.loadUserData();
    });

    window.addEventListener('user:signup', () => {
      this.updateLoggedInStatus(true);
      this.loadUserData();
    });

    window.addEventListener('user:logout', () => {
      this.updateLoggedInStatus(false);
      this.clearUserData();
    });
  }

  loadUserData() {
    this.storage.get('userdata').then((value) => {
      if (value) {
        this.Name = value.First_Name + ' ' + value.Last_Name;
        this.Email = value.Email;
        this.Username = value.Username;
        this.Img =
          value.Image && value.Image !== ''
            ? 'https://app.walba.app/' + value.Image
            : 'https://www.gravatar.com/avatar?d=mm&s=140';
            
        this.notifService.init(value.Id_User || value.Id);
        this.notifService.unreadCount$.subscribe(count => {
          this.unreadCount = count;
        });
        
        this.notifService.unreadMessageCount$.subscribe(count => {
          this.unreadMessageCount = count;
        });
      }
    });
  }

  clearUserData() {
    this.Name = '';
    this.Email = '';
    this.Username = '';
    this.Img = '';
    this.notifService.stop();
  }

  logout() {
    this.profileDropdownOpen = false;
    this.userData.logout().then(() => {
     return window.location.href = 'https://walba.app';
    });
  }

  openTutorial() {
    this.menu.enable(false);
    this.storage.set('ion_did_tutorial', false);
    this.router.navigateByUrl('/tutorial');
  }

  isSignupPage(): boolean {
  return this.router.url.includes('/signup');
}
}
